import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from './locales/en.json'
import it from './locales/it.json'
import fr from './locales/fr.json'
import de from './locales/de.json'
import cs from './locales/cs.json'
import el from './locales/el.json'

const LANG_STORAGE_KEY = 'ecoempower:lang'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      it: { translation: it },
      fr: { translation: fr },
      de: { translation: de },
      cs: { translation: cs },
      el: { translation: el },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'it', 'fr', 'de', 'cs', 'el'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LANG_STORAGE_KEY,
      caches: ['localStorage'],
    },
  })

export { LANG_STORAGE_KEY }
export default i18n
